import { render, staticRenderFns } from "./TradeDocuments.vue?vue&type=template&id=67e206a6&scoped=true&"
import script from "./TradeDocuments.vue?vue&type=script&lang=js&"
export * from "./TradeDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e206a6",
  null
  
)

export default component.exports